import { useCallback, useState } from 'react';
export const testProperty = (property, el) => {
  const style = window.getComputedStyle(el);
  const duration = style.getPropertyValue(`${property}-duration`);
  return duration.length <= 2 && (Number.isNaN(parseFloat(duration)) || parseFloat(duration) === 0);
};
export const useAnimationDisabled = params => {
  const [propertyDisabled, setPropertyDisabled] = useState(false);
  const property = (params == null ? void 0 : params.property) || 'animation';
  const setRef = useCallback(node => {
    if (node) {
      setPropertyDisabled(testProperty(property, node));
    }
  }, [property]);
  return [setRef, Boolean(propertyDisabled || (params == null ? void 0 : params.disabled))];
};